import { Avatar } from '@mui/material';
import useTrainer from '../hooks/useTrainer';

const Logo = () => {
  const { data } = useTrainer();
  if (!data) {
    return <Avatar>T</Avatar>;
  }

  const logo = data?.webPage?.logo;
  if (!logo || !logo.url) {
    return <Avatar>T</Avatar>;
  }

  return <img alt="logo" width={72} height={72} src={logo.url} />;
};

export default Logo;
